import useAiChatFavicon from "../../hooks/useAiChatFavicon.ts";

export default function AiChatFaviconController() {
  useAiChatFavicon();
  return null;
}
